import { assignPolicyMenuItemName } from 'owa-locstrings/lib/strings/assignpolicymenuitemname.locstring.json';
import loc from 'owa-localize';
import getRetentionPolicySubMenuProps from './getRetentionPolicySubMenuProps';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/components/ContextualMenu';
import { FolderForestTreeType } from 'owa-favorites-types';
import { SHARED_FOLDERS_TREE_TYPE } from 'owa-folders-constants';
import DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import RetentionTagType from 'owa-service/lib/contract/RetentionTagType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';

/**
 * Utility to create the retention policy menu item in the context menu
 * @param selectedArchiveTag currently selected archive tag
 * @param selectedDeleteTag currently selected delete tag
 * @param treeType treetype of the folder to which this item belongs
 * @param distinguishedFolderId distinguished folder id of the folder
 * @param onArchivePolicyClickedCallback archive policy clicked callback
 * @param onDeletePolicyClickedCallback delete policy clicked callback
 */
export default function getRetentionPolicyMenuItem(config: {
    selectedArchiveTag: RetentionTagType;
    selectedDeleteTag: RetentionTagType;
    treeType: FolderForestTreeType;
    distinguishedFolderId: DistinguishedFolderIdName;
    onArchivePolicyClickedCallback: (
        ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: IContextualMenuItem
    ) => void;
    onDeletePolicyClickedCallback: (
        ev?: React.KeyboardEvent<HTMLElement> | React.MouseEvent<HTMLElement>,
        item?: IContextualMenuItem
    ) => void;
}): IContextualMenuItem {
    // RetentionPolicy not available for consumer or when flight disabled
    if (isConsumer()) {
        return null;
    }

    const userConfiguration = getUserConfiguration();
    const { treeType } = config;
    const retentionPolicyTagList = userConfiguration.RetentionPolicyTags;
    // Do not show context menu item if the policy list is empty or tree type is shared folders
    if (
        !retentionPolicyTagList ||
        retentionPolicyTagList.length === 0 ||
        treeType === SHARED_FOLDERS_TREE_TYPE
    ) {
        return null;
    }

    return {
        key: 'AssignPolicy',
        name: loc(assignPolicyMenuItemName),
        disabled: false,
        subMenuProps: getRetentionPolicySubMenuProps({
            ...config,
            showTagSelection: true,
            retentionPolicyTagList: retentionPolicyTagList,
            hasArchive: !!userConfiguration.SessionSettings.HasArchive,
        }),
    };
}
